import { CommonModule } from '@angular/common';
import { Component, ViewChild, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbPopover, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

import { IdentityService } from '@digital-platform/rs-auth/services';
import { IconComponent } from '@digital-platform/rs-shared/ui-brand';
import { AccountDropdownBoxComponent } from '../account-dropdown-box/account-dropdown-box.component';

@Component({
  selector: 'digital-platform-account-dropdown-button',
  standalone: true,
  imports: [
    CommonModule,
    NgbPopoverModule,
    RouterModule,
    IconComponent,
    AccountDropdownBoxComponent,
  ],
  templateUrl: './account-dropdown-button.component.html',
  styleUrls: ['./account-dropdown-button.component.scss'],
})
export class AccountDropdownButtonComponent {
  @ViewChild('popoverRef') popover!: NgbPopover;
  public identityService: IdentityService = inject(IdentityService);
}
